import { useRef } from 'react';

import { useEventListener, useIsMobile } from '@utils/hooks';

const DOWN_KEYCODE = 40;
const UP_KEYCODE = 38;

const useKeyboardNavigation = (disabled?: boolean) => {
  const isMobile = useIsMobile();
  const buttonsRef = useRef<HTMLElement[]>([]);

  useEventListener(
    'keydown',
    (e: any) => {
      const code: number = e.keyCode;
      if (code === UP_KEYCODE || code === DOWN_KEYCODE) {
        e.preventDefault();
        const active = document.activeElement as HTMLElement;
        const buttons = buttonsRef.current;
        if (active) {
          const first = buttons[0];
          const last = buttons[buttons.length - 1];
          const isDown = code === DOWN_KEYCODE;
          if (!buttons.includes(active)) {
            (isDown ? first : last)?.focus();
          } else {
            const next = (
              isDown ? active.nextElementSibling : active.previousElementSibling
            ) as HTMLElement;
            if (buttons.includes(next)) next?.focus();
          }
        }
      }
    },
    { disabled: disabled || isMobile }
  );

  return buttonsRef.current;
};

export default useKeyboardNavigation;
